<template>
 
  <div class="q-pa-md">
    <!-- <div class="loaderClass" v-if="isLoading">
           <q-spinner-cube color="blue" size="6em"/>
    </div> -->
    <!-- <div class="q-pa-md" v-if="!isLoading && data.length != 0"> -->
    
    <q-tabs
        v-model="tab"
        indicator-color="blue"
        class="text-teal"
        align="left"
         >
        <q-tab name="history" style="margin-left:16px"><q-btn>History</q-btn></q-tab>
        <q-tab name="recent" style="margin-left:10px"><q-btn>Recent</q-btn></q-tab>
       

      </q-tabs>

      <div v-if="tab==='recent'">
        <div class="introWindow">
        <q-table
        :loading="isLoading"
        ref="table"
        title="Price Optimization Results History"
        :class="expanded===true?'tabl':'tbl'"
        :data ="rows"
        :columns="columns"
        :hide-pagination="true"
        no-data-label="No Result History Found"
      >
       
      <template v-if="isLoading===false" v-slot:top-row>
        <q-th align="left" bold :style="{fontsize:'40px',color:'red'}">
          New Job ↓
        </q-th>
        </template>

        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              v-for="col in columns"
              :key="col.name"
              :props="props"
              class="headerText"
              :style="{ fontSize: '15px', color: 'dodgerblue' }"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>

        <template v-slot:body="props">
          <q-tr :props="props" >
            <q-td key="id" :props="props">
              Price_Optimization_Job_{{ props.row.jobnum}}
            </q-td>

            <q-td key="insert_time_stamp" :props="props">
           
              {{(props.row.insert_time_stamp)||(props.row.insert_time_stamp)!= undefined ?new Date(props.row.insert_time_stamp).toLocaleString():'No Data'}}
            </q-td>
             <q-td key="request_type" :props="props">
           
              {{(props.row.request_type)}}
            </q-td>
            <q-td key="mode" :props="props">
           
              {{(props.row.mode)}}
            </q-td>

            <q-td key="optim_details" :props="props">
              <q-td auto-width>
                <q-btn
                  size="sm"
                  color="blue"
                  round
                  @click="expanded = !expanded"
                  :icon="expanded? 'remove' : 'add'"
                />
              </q-td>
            </q-td>

            <q-td key="status" :props="props">
              <span
                v-if="
                  'SUBMITTED' === props.row.status ||
                  'PROCESSING' === props.row.status
                "
                ><div class="box-m">
                  <strong>{{ props.row.status }}</strong>
                </div>
              </span>

              <span
                v-if="
                  'READY' === props.row.status"
                ><div class="box-h">
                  <strong>{{ props.row.status }}</strong>
                </div>
              </span>
              
            </q-td>

            <q-td auto-width>
              <!-- <router-link :to="{ name: 'PriceOptimizationResults', params: { jobid: props.row.id }}"> -->
              <q-btn v-if="props.row.status === 'READY'"
                unelevated
                size="12px"
                rounded
                color="blue"
                label="Show Result"
                class="text-white"
                @click="showResult(props.row.id)"
              />
              <!-- <q-btn v-if="props.row.status === 'SUBMITTED' ||
                  'PROCESSING' === props.row.status"
                 unelevated
                size="12px"
                rounded
                color="black"
                label="Generating"
              /> -->
              <!-- </router-link> -->
              
                <q-linear-progress
                 v-if="props.row.status === 'SUBMITTED' ||'PROCESSING' === props.row.status"
                 rounded
                 stripe
                size="15px" 
                :value="props.row.job_progress*0.01" >
               <div class="absolute-full flex flex-center">
        <q-badge  outline="hidden" text-color="black" :label="(props.row.job_progress) + '%'"></q-badge>
      </div>
                </q-linear-progress>

                </q-td>
          </q-tr>
        

          <q-tr v-show="expanded && props.row.mode=='online'" :props="props">
            <q-td colspan="100%">
              <q-table
                title="Price Optimization Details"
                :data="props.row.optim_details[0]['product_list']"
                :columns="columns2"
                row-key="name"
              />
            </q-td>
          </q-tr>

          <q-tr v-show="expanded && props.row.mode=='offline'" :props="props">
            <q-td colspan="100%">
              <q-table
              title="Price Optimization Details"
               
                :data="rows"
                hide-bottom
               
              >
              <template v-slot:header="props">
                  <q-tr :props="props" >
                    <q-th style="font-size:15px; text-align:left">Offline</q-th>
                    
                    
                  </q-tr>
                </template>
               
              <template v-slot:body="props">
               
                  <tr :props="props" style="text-align:left;">
                   <p style="padding:10px 20px 0px 20px;">  <span style="font-weight:500"> Expected Price Type :</span>{{' '+props.row['price-suggestion-type']}}</p>
                  </tr>
                  <tr :props="props" style="text-align:left">
                  <p style="padding:10px 20px 0px 20px;"> <span style="font-weight:500"> Uploaded Files : </span> {{ props.row['product_list'][0]['historicalData']}}</p>
                  </tr>
           
              </template>


              
              </q-table>
            </q-td>
          </q-tr>


        </template>
      </q-table>
      </div>

      </div>
      <div v-else>
    <div class="introWindow">
      
      <q-table
        :loading="isLoading"
        ref="table"
        title="Price Optimization Results History"
         class="my-sticky-virtscroll-table"
         virtual-scroll
        :virtual-scroll-sticky-size-start="48"
        :data="data"
        :columns="columns"
        no-data-label="No Result History Found"
      >
       
      <template v-if="isLoading===false" v-slot:top-row>
        <q-th align="left" bold :style="{fontsize:'40px',color:'red'}">
          New Job ↓
        </q-th>
        </template>

        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              v-for="col in columns"
              :key="col.name"
              :props="props"
              class="headerText"
              :style="{ fontSize: '16px', color: 'dodgerblue' }"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>

        <template v-slot:body="props">
          
          <q-tr :props="props">
            <q-td key="id" :props="props">
              Price_Optimization_Job_{{ props.row.jobnum }}
            </q-td>

            <q-td key="insert_time_stamp" :props="props">
           
              {{(props.row.insert_time_stamp)||(props.row.insert_time_stamp)!= undefined ?new Date(props.row.insert_time_stamp).toLocaleString():'No Data'}}
            </q-td>
             <q-td key="request_type" :props="props">
           
              {{(props.row.request_type)}}
            </q-td>

             <q-td key="mode" :props="props">
           
              {{(props.row.mode)}}
            </q-td>


            

            <q-td key="optim_details" :props="props">
              <q-td auto-width>
                <q-btn
                  size="sm"
                  color="blue"
                  round
                  @click="props.expand = !props.expand"
                  :icon="props.expand ? 'remove' : 'add'"
                />
              </q-td>
            </q-td>

            <q-td key="status" :props="props">
              <span
                v-if="
                  'SUBMITTED' === props.row.status ||
                  'PROCESSING' === props.row.status
                "
                ><div class="box-m">
                  <strong>{{ props.row.status }}</strong>
                </div>
              </span>

              <span
                v-if="
                  'READY' === props.row.status"
                ><div class="box-h">
                  <strong>{{ props.row.status }}</strong>
                </div>
              </span>
              
            </q-td>

            <q-td auto-width>
              <!-- <router-link :to="{ name: 'PriceOptimizationResults', params: { jobid: props.row.id }}"> -->
              <q-btn v-if="props.row.status === 'READY'"
                unelevated
                size="12px"
                rounded
                color="blue"
                label="Show Result"
                class="text-white"
                @click="showResult(props.row.id)"
              />
              <!-- <q-btn v-if="props.row.status === 'SUBMITTED' ||
                  'PROCESSING' === props.row.status"
                 unelevated
                size="12px"
                rounded
                color="black"
                label="Generating"
              /> -->
              <!-- </router-link> -->
              
                <q-linear-progress
                 v-if="props.row.status === 'SUBMITTED' ||'PROCESSING' === props.row.status"
                 rounded
                 stripe
                size="15px" 
                :value="props.row.job_progress*0.01" >
               <div class="absolute-full flex flex-center">
        <q-badge  outline="hidden" text-color="black" :label="(props.row.job_progress) + '%'"></q-badge>
      </div>
                </q-linear-progress>

                </q-td>
          </q-tr>
          <q-tr v-show="props.expand && props.row.mode=='online'" :props="props">
            <q-td colspan="100%">
              <q-table
                title="Price Optimization Details"
                :data="props.row.optim_details[0]['product_list']"
                :columns="columns2"
                row-key="name"
              />
            </q-td>
          </q-tr>

         
          
          <q-tr v-show="props.expand && props.row.mode=='offline'" :props="props">
            <q-td colspan="100%">
              <q-table
              title="Price Optimization Details"
               
                :data="props.row.optim_details"
                hide-bottom
               
              >
              <template v-slot:header="props">
                  <q-tr :props="props" >
                    <q-th style="font-size:15px; text-align:left">Offline</q-th>
                    
                    
                  </q-tr>
                </template>
               
              <template v-slot:body="props">
                 
                  <tr :props="props" style="text-align:left;">
                   <p style="padding:10px 20px 0px 20px;">  <span style="font-weight:500"> Expected Price Type :</span>{{' '+props.row['price-suggestion-type']}}</p>
                  </tr>
                  <tr :props="props" style="text-align:left">
                  <p style="padding:10px 20px 0px 20px;"> <span style="font-weight:500"> Uploaded Files : </span> {{ props.row['product_list'][0]['historicalData']}}</p>
                  </tr>
           
              </template>


              
              </q-table>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    </div>
    

            <!-- <div style="margin-top:50px; width:100%;">
              <div style="width:98%;margin-left:auto;margin-right:auto;">
            <iframe

                v-if=" is_dashboard_visible"
                width="100%"
                height="720"

                :src= "url"
                
                
                >
            </iframe>
              </div>
            </div> -->

    
    
    <!-- </div> -->
  </div>

 
</template>

<script>
export default {
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      isLoading: true,
      tab:"history",
      expanded:true,
      last_data:0,
      
      columns: [
        {
          name: "id",
          align: "left",
          label: "Job Submission Number",
          field: "id",
          sortable: true,
        },
        {
          name: "insert_time_stamp",
          label: "Job Submission Time",
          field: "insert_time_stamp",
          align: "left",
          sortable: true,
        },
        {
          name: "request_type",
          label: "Type",
          field: "request_type",
          align: "left",
          sortable: true,
        },
        {
          name: "mode",
          label: "Mode",
          field: "mode",
          align: "center",
        },
        {
          name: "optim_details",
          label: "Optim Details",
          field: "optim_details",
          align: "left",
        },
         {
          name: "status",
          label: "Status",
          field: "status",
          align: "center",
        },
        {
          name: "job_progress",
          label: "Job progress",
          field: "job_progress",
          align: "center",
          hidden:true,
        },
      ],
      columns2: [
        {
          name: "product",
          align: "left",
          label: "Product",
          field: "product",
          sortable: true,
        },
        {
          name: "product_variant",
          label: "Product Variant",
          field: "product_variant",
          align: "left",
        },
        {
          name: "min_cost_price",
          label: "Min Cost Price",
          field: "min_cost_price",
          align: "left",
        },
      ],

      columns3: [
        {
          name: "price_type",
          align: "left",
          label: "Expected Price type",
          field: "price_type",
         
        },
        {
          name: "uploaded_files",
          label: "Uploaded Files",
          field: "uploaded files",
          align: "left",
        },
        
      ],

     
      data: [],
      lis: [],
      rows:[],
      url:"",
      dash_board_id:"",
      is_dashboard_visible: false,
    };
  },
  created() {
     var resultshistoryURL = this.api_url + "/resultshistory/all/" + this.$org_id.label;
     
    this.$http
      .get(resultshistoryURL)
      .then((response) => {
        let result = response.data;
        // console.log(response.data);
        let data = result.map((items) => {
          return {
            ...items,
            //jobnum: count++
          };
        });
        let count = data.length;
        this.last_data = data.length;
       //const sortedData = data.slice().sort(function(a,b){let c = new Date(a.insert_time_stamp); let d = new Date(b.insert_time_stamp); return c-d});
       const sortedData = data.slice().sort(function(a,b){let c = new Date(a.insert_time_stamp); let d = new Date(b.insert_time_stamp); return d-c}).map((items)=>{
         return {
            ...items,
            jobnum: count--
          };
        });
    
         console.log(sortedData)
        this.data = sortedData;
        this.isLoading = false;
        this.rows[0] = this.data[0];   
         console.log(this.rows[0])     
      })
      .catch((err) => {
        this.$q.notify({
          message: err,
          color: "negative",
        });
        this.isLoading = false;
        // console.log(err);
      });
   

     
      
      
  },
  methods: {
     reload(){
        if(this.data[0]['status'] === 'SUBMITTED'){
          setInterval(window.location.reload(),20000);
        }
     },
    showResult(data) {
      // const id = this.data[]
      let jobnum = 0; 
      for(var i=0;i<this.data.length;++i){
        if(data === this.data[i]['id']){
          let num = i;
          jobnum = num;
          console.log(num)
        }
      }
      console.log(jobnum)
      if(this.data[jobnum]['request_type'] === "pricing-revenue"){
      this.$router.push({
        name: "PriceOptimizationResults",
        params: {
          jobid: data,
        },
      });
      }else if(this.data[jobnum]['request_type'] === "pricing-volume"){
         this.$router.push({
        name: "VolumeRecommendation",
        params: {
          jobid: data,
        },
      });
      }else if(this.data[jobnum]['request_type'] === "pricing-profit"){
         this.$router.push({
        name: "ProfitRecommendation",
        params: {
          jobid: data,
        },
      });
      }else{
      this.$router.push({
        name: "PriceOptimizationResults",
        params: {
          jobid: data,
        },
      });
    }
  },
  // get_dashboard(){
       
  //       // this.$q.loading.show();
  //       // this.$q.loading.hide();
      
         
        

  //       var getURL = this.api_url + "/quicksight/get_embed_url/" + this.dash_board_id ;
  //      this.$http

  //     .get(getURL)
  //     .then((response) => {
  //       let result = response;
  //       console.log(result)
       
  //       console.log(response.data);
        
  //       this.url = response.data;
       
  //       console.log(this.url);
  //        this.$q.loading.hide();

  //       this.is_dashboard_visible = true;
       
  //     })
  //     .catch((err) => {
  //       this.$alert("If you have recently submitted a job, please wait for 24 hours to get the analysis", "Could not load dashboard","error");
  //       this.$q.loading.hide();
  //       //console.log(err);
  //     });

    
  //     }
  },

mounted(){
      this.$q.loading.show({
       message: "Authenticating please wait..",
     });

      if(this.$cookies.isKey("login_authentication"))
     {
       let encryptedText = this.$cookies.get("login_authentication");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/priceoptimization/resultshistory");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else if(this.$cookies.isKey("login_authentication1"))
     {
       let encryptedText = this.$cookies.get("login_authentication1");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/priceoptimization/resultshistory");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else if(this.$cookies.isKey("login_authentication2"))
     {
       let encryptedText = this.$cookies.get("login_authentication2");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/priceoptimization/resultshistory");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else{

       this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

     }

   
  

    

    // var get_id_URL = this.api_url + "/quicksight/get_priceoptim_dashboard_id" ;
    //    this.$http
    //   .get(get_id_URL)

    //   .then((response) => {

        
    //     let result = response;
    //     console.log("result")
    //     console.log(result)
        
    //     console.log("response.data");
    //     console.log(response.data);
    //     this.dash_board_id = response.data;
    //     console.log(this.dash_board_id);

    //     if(this.dash_board_id == false)
    //     {
    //       this.$alert("If you have recently submitted a job, please wait for 24 hours to get the analysis", "Could not load dashboard","error");
          
    //       this.$q.loading.hide();
    //       return;
    //     }
    //     console.log("this.dash_board_id");
    //     console.log(this.dash_board_id);

    //     this.get_dashboard();
       
    //   }).catch((err) => {
    //      this.$alert("If you have recently submitted a job, please wait for 24 hours to get the analysis", "Could not load dashboard","error");
    //     this.$q.loading.hide();
    //     console.log(err);
    //   });

  }
};
</script>

<style >
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");

.q-tab__label{
  font-weight:bold;
  color:black;
}
.tbl{
  height:200px;
}

.q-table__bottom
.q-badge{
  background-color:transparent;
}
.set-position {
  position: inherit;
  bottom: 22px;
  text-align: center;
}

.my-sticky-virtscroll-table .q-table__top,
.my-sticky-virtscroll-table .q-table__bottom,
.my-sticky-virtscroll-table thead tr:first-child th {
  background-color: #fff;
}
.my-sticky-virtscroll-table thead tr th {
  position: sticky;
  z-index: 1;
}
.my-sticky-virtscroll-table thead tr:last-child th {
  /* height of all previous header rows */
  top: 48px;
}
.my-sticky-virtscroll-table thead tr:first-child th {
  top: 0;
}
.heading {
  font-family: "Montserrat", sans-serif;
  color: blue;
  font-size: 1.5rem;
}
.introWindow {
  text-align: center;
  border-radius: 4px;
  padding: 1rem 1rem 0;
  background:transparent;
  /* background-image: radial-gradient(circle, #2678ca, #082f7a); */
  /* box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12); */
  transition: 0.3s;
  /*height: 100vh;*/
}
.loaderClass {
  margin: 40vh 0 0 40%;
}
.nodata {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 50%;
  text-align: center;
  height: 100px;
  padding-top: 2.5rem;
  margin-top: 40vh;
  margin-left: 25%;
}
.box-h {
  align-items: center;
  background-color: #2db051;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 7rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.box-m {
  align-items: center;
  background-color: #fb9300;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 7rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
</style>
